/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gnosis_chain_about = () => `Gnosis Chain operates as an execution-layer Ethereum Virtual Machine (EVM) chain, utilizing the xDAI stablecoin for transactions and fee payments. Its security is ensured by the Gnosis Beacon Chain (GBC), which employs a Proof-of-Stake consensus mechanism akin to Cardano and Solana. Users stake GNO tokens to participate in transaction validation, earning additional GNO rewards for contributing to network security.`
